import { useIntl } from 'react-intl';

import './reportUnavailable.scss';

type Props = {
  availableFrom: string | null;
};

/**
 * Shown when the route is opened for a campaign that has not reached
 * `endDate + 1 day`. Deliberately replaces the whole report — header included —
 * so nothing suggests data is merely still loading.
 */
export default function ReportUnavailable({ availableFrom }: Readonly<Props>) {
  const { formatMessage, formatDate } = useIntl();

  return (
    <section className="reportUnavailable">
      <i aria-hidden="true" className="fa-regular fa-clock reportUnavailable__icon" />
      <h1 className="reportUnavailable__title">
        {availableFrom
          ? formatMessage(
              {
                defaultMessage: 'This report will be available on {date}',
                id: 'doohReport.unavailable.title'
              },
              { date: formatDate(new Date(availableFrom), { day: 'numeric', month: 'long', year: 'numeric' }) }
            )
          : formatMessage({
              defaultMessage: 'This report is not available yet',
              id: 'doohReport.unavailable.titleNoDate'
            })}
      </h1>
      <p className="reportUnavailable__description">
        {availableFrom
          ? formatMessage({
              defaultMessage: 'DOOH reports open one day after the campaign ends, and refresh every 7 days after that.',
              id: 'doohReport.unavailable.description'
            })
          : formatMessage({
              defaultMessage:
                'This campaign has no end date set, so there is no date from which the report can open yet.',
              id: 'doohReport.unavailable.descriptionNoEndDate'
            })}
      </p>
    </section>
  );
}
